export const PACKS_BASE_PATH = 'packs/v2';
export const SHOP_TABS_BASE_PATH = 'shoptabs/v2';
export const CAROUSELS_BASE_PATH = 'carousels/v2';
export const IN_APP_EVENTS_BASE_PATH = 'in-app-events/v2';
export const FILES_BASE_PATH = 'files/v2';
export const ACTIVATIONS_BASE_PATH = 'activations/v2';
export const GIFTS_BASE_PATH = 'gift/api/v1';
export const IAP_PRICING_BASE_PATH = 'iap-pricing/v2';
